import * as React from 'react';
import { Link } from 'react-router-dom';
import KeyboardDoubleArrowUpIcon from '@mui/icons-material/KeyboardDoubleArrowUp';
import Color from './Color';
import FontSize from './FontSize';
import MenuIcon from '@mui/icons-material/Menu';

const navbar = { 
    fontWeight: 600, 
    fontSize: FontSize.Big, 
    color: Color.Sub 
};

const logo = { 
    fontWeight: 600, 
    fontSize: FontSize.Big, 
    color: Color.Main,
};

function Header() {

    return (
        <>
            <a href="/#" className="scrollToTop"><KeyboardDoubleArrowUpIcon ></KeyboardDoubleArrowUpIcon></a>
            <header className="header-section">
                <div className="overlay">
                    <div className="container">
                        <div className="row d-flex header-area">
                            <nav className="navbar navbar-expand-lg navbar-light">
                                <a className="navbar-brand" href="/" style={navbar}>
                                    <span className="logo-home" />APOL<span style={logo}>LO</span>
                                </a>
                                <button className="navbar-toggler collapsed" type="button" data-bs-toggle="collapse" data-bs-target="#navbar-content">
                                    <MenuIcon/>
                                </button>
                                <div className="collapse navbar-collapse justify-content-end" id="navbar-content">
                                    <ul className="navbar-nav mr-auto mb-2 mb-lg-0">
                                        <li className="nav-item">
                                            <a className="nav-link active" aria-current="page" href="/">Home</a>
                                        </li>
                                        <li className="nav-item">
                                            <a className="nav-link" aria-current="page" href="/question">Question</a>
                                        </li>
                                        <li className="nav-item">
                                            <a className="nav-link" aria-current="page" href="/guide">Guide</a>
                                        </li>
                                        <li className="nav-item">
                                            <a className="nav-link" aria-current="page" href="/product">Consumer</a>
                                        </li>
                                        <li className="nav-item">
                                            <a className="nav-link" aria-current="page" href="/guide">Merchant</a>
                                        </li>
                                        <li className="nav-item">
                                            <Link to="/signin" className="nav-link" >Log In</Link>
                                        </li>
                                    </ul>
                                    <div className="right-area header-action d-flex align-items-center">
                                        <Link to="/signup" className="cmn-btn">Register</Link>
                                    </div>
                                </div>
                            </nav>
                        </div>
                    </div>
                </div>
            </header>
        </>
    );
}

export default Header;